module.exports = __webpack_public_path__ + "img/about-mobile.ee844ab6.jpg";